import request from '@/request/ts-index';
var QueryApi;
(function (QueryApi) {
    QueryApi["queryHome"] = "/queryHome";
    QueryApi["queryRandom"] = "/queryRandom";
    QueryApi["queryRingRel"] = "/queryRingRel";
    QueryApi["queryCategoryVideos"] = "/queryCategoryVideos";
    QueryApi["queryCategory"] = "/queryCategory";
    QueryApi["queryVideoByCategoryId"] = "/queryVideoByCategoryId";
})(QueryApi || (QueryApi = {}));
export const queryRandom = (params) => {
    return request.get(QueryApi.queryRandom, {
        params: params
    });
};
export const queryRingRel = (params) => {
    return request.get(QueryApi.queryRingRel, {
        params: params
    });
};
export const queryCategoryVideos = (params) => {
    return request.get(QueryApi.queryCategoryVideos, {
        params: params
    });
};
export const queryCategory = (params) => {
    return request.get(QueryApi.queryCategory, {
        params: params
    });
};
// 获取某个栏目数据并且是有pagesize
export const queryVideoByCategoryId = (params) => {
    return request.get(QueryApi.queryVideoByCategoryId, {
        params: params
    });
};
export const queryHome = (params) => {
    return request.get(QueryApi.queryHome, {
        params: params
    });
};
